<mat-form-field subscriptSizing="dynamic" class="min-w-48">
  <mat-label>{{ label() }}</mat-label>
  <mat-select #select [value]="selectedId()" [disabled]="disabled()" (selectionChange)="onSelectionChange($event.value)">
    @for (priceList of priceLists(); track priceList.id) {
      <mat-option [value]="priceList.id">{{ priceList.name }}</mat-option>
    }
  </mat-select>
</mat-form-field>
